var video_block = document.querySelector('.video-embed');

if(video_block){
    var video_triggers = document.querySelectorAll('.video-titles ul li a');
    video_triggers.forEach(function(video_trigger){

        video_trigger.addEventListener('click',function(event){
            event.preventDefault();

            let iframe_src = this.getAttribute("href");
            let iframe_title = this.getAttribute("aria-label");
            let iframe_id = this.getAttribute("data-toggle");
        
            let iframe = document.querySelector('.video-embed iframe');
            iframe.setAttribute("id", iframe_id);
            iframe.setAttribute("title", iframe_title);
            iframe.setAttribute("src", iframe_src);

        });

    });

    document.addEventListener("DOMContentLoaded", function () {

        let iframe_src = video_triggers[0].getAttribute("href");
        let iframe_title = video_triggers[0].getAttribute("aria-label");
        let iframe_id = video_triggers[0].getAttribute("data-toggle");

        var iframe = document.createElement("iframe");

        iframe.setAttribute("id", iframe_id);
        iframe.setAttribute("role","presentation");
        iframe.setAttribute("title", iframe_title);
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("src", iframe_src);

        $('#video_container').html("");
        $('#video_container').addClass("show");
        $('#video_container').append(iframe);
    });
    

}